<script>
    import { getContext, onMount } from 'svelte';
    import { axisTop } from 'd3-axis';
    import { select } from 'd3-selection';

    import TimelineNavigator from './TimelineNavigator.svelte';

    export let headerKey;
    export let layout;

    const { width, time_range, moving_time, timeScale } = getContext(headerKey);
    const { headerHeight: height } = layout;

    // --- Axis
    let axisG;
    const timeAxis = axisTop(timeScale);

    $: updateTime($time_range);

    function updateTime(range) {
        timeScale.domain(range.map((t) => new Date(t)));
        createAxis();
    }

    function createAxis() {
        if (axisG) {
            select(axisG)
                .call(timeAxis)
                .call((g) => g.select('.domain').remove());
        }
    }

    onMount(() => createAxis());

    // --- Navigation
    let navigator;
</script>

<TimelineNavigator
    {time_range}
    {moving_time}
    {layout}
    bind:handles={navigator}
/>

<svelte:window
    on:mousemove={navigator.move}
    on:mouseup={navigator.stop}
/>

<div
    id="header"
    class="no-select"
    style={`height:${height}px;`}
    on:dblclick={navigator.reset}
    on:mousedown={navigator.start}
>
    <svg {width} {height}>
        <g bind:this={axisG} transform={`translate(0, ${height})`} />
    </svg>
</div>

<style>
    #header {
        position: absolute;
        background-color: white;
    }
</style>
